import EditorImg from 'lowcode/components/EditorImg';
import { Progress } from 'antd';
import EditorLink from 'lowcode/components/EditorLink';
import { IProductItem } from '../../../type';
import { useMembersStore } from '../../../MembersProvider';
import Button from '@/components/UI/Button';
import { useLang } from '@/i18n';
import { EuEcoCredits } from '@/components/MembersDay/FY2024/CommonElement/EuEcoCredits';
import getLocal from '@/app/utils/getLocal';
import { getProductUrl } from '@/service/membersday';
import { message } from '@/components/UI/Message';
import gtm from '@/utils/gtm';
import { EU_SITES, NA_SITES, SAVE_SITES } from '@/constants/membersday';
import { signupCookie } from '@/utils/cookies/signupCookie';

export default ({ item, list_name }: { item: IProductItem; list_name: string }) => {
    const { isLogin, secKillisBegin } = useMembersStore();
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const hideProgress = EU_SITES.includes(locale) || locale === 'kr' || locale === 'za';

    const handleClick = (id: string, title: string, toDetail?: boolean) => {
        if (!isLogin) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'ecocredits_join_login',
                list_name,
                button_name: t('flashsale.product_price_buy_now'),
            });
            const pathname2 = location.pathname;
            signupCookie?.({
                sector_name: item.title,
                entry_position: 3,
            });
            location.href = `/${locale}/login?redirect=${pathname2}`;
            return;
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: `${t('flashsale.product_price_buy_now')}_${title}`,
        });
        getProductUrl(id, locale).then((res) => {
            if (res.code !== '0') {
                return message.error(res.message);
            }
            const { purchaseUrl, productUrl } = res.data;
            // toDetail区分点击标题还是购买
            const url = toDetail ? productUrl : purchaseUrl;

            if (isSafari) {
                location.href = url;
            } else {
                try {
                    window.open(url, '_blank');
                } catch {
                    location.href = url;
                }
            }
        });
    };

    const percent = Math.ceil(((item.displayInventoryQuantity - item.inventoryQuantity) / item.displayInventoryQuantity) * 100) || 0;

    const btn = () => {
        if (!secKillisBegin) {
            return (
                <Button className="buy_button" disabled>
                    {t('flashsale.coming_soon')}
                </Button>
            );
        }
        if (item.inventoryQuantity === 0) {
            return (
                <Button className="buy_button" disabled>
                    {t('flashsale.sold_out')}
                </Button>
            );
        }
        return (
            <Button className="buy_button" onClick={() => handleClick(item.id, item.title)}>
                {t('flashsale.product_price_buy_now')}
            </Button>
        );
    };

    return (
        <div className="product_item">
            {item.discountPercent && (
                <div className="off">
                    {SAVE_SITES.includes(locale) ? (
                        item.disparityPrice
                    ) : (
                        <>
                            {item.discountPercent}%<span>{t('flashsale.off')}</span>
                        </>
                    )}
                </div>
            )}
            <div className="img">
                <EditorImg pc={item.imageUrl} />
            </div>
            <EuEcoCredits />
            <div className="name">
                {NA_SITES.includes(locale) ? 'EcoFlow ' : ''}
                {item.title.replace(`(${t('product_price_member')})`, '')}
            </div>
            {item.subtitle1 && <p className="subtitle">{item.subtitle1}</p>}
            <div>
                <div className="price">
                    {item.memberPrice || item.price}
                    <span>{item.compareAtPrice}</span>
                </div>
                {!hideProgress && (
                    <>
                        <Progress className="line" status="active" showInfo={false} percent={percent} strokeColor={{ from: '#FFBD3C', to: '#FFBD3C' }} />

                        <p className="stock">
                            {t('flashsale.product_quantity')}: {item.displayInventoryQuantity - item.inventoryQuantity}
                            <span>
                                {t('flashsale.product_stock')}: {item.inventoryQuantity}
                            </span>
                        </p>
                    </>
                )}
                <div className="tools">
                    {locale === 'kr' && (
                        <EditorLink style={{ width: '100%' }} href={item.productUrl} target="_blank">
                            <Button className="buy_button learn_more">{t('product_price_learn_more')}</Button>
                        </EditorLink>
                    )}
                    {btn()}
                </div>
            </div>
        </div>
    );
};
